const serverURL = function (path) {
  // return "http://localhost:3000/" + path;
  return "https://greenify-your-life.herokuapp.com/" + path;
};

export default serverURL;

// import serverURL from "../ServerURL";
// serverURL(path);
